/* eslint-disable css-modules/no-unused-class */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// jl-design-system
import InputManageCursor from 'jl-design-system/elements/input-manage-cursor/InputManageCursor';

import styles from './payment-types.scss';

class InputCreditCard extends PureComponent {

  static propTypes = {
    ...InputManageCursor.propTypes,
    inputClassName: PropTypes.string,
    inputWrapperClassName: PropTypes.string,
  };

  static defaultProps = {
    ...InputManageCursor.defaultProps,
    inputWrapperClassName: '',
  };

  render() {

    const {
      inputWrapperClassName,
    } = this.props;

    return (
      <div
        className={styles[inputWrapperClassName]}
        data-test="field-wrapper"
      >
        <InputManageCursor {...this.props} data-test="input-manage-cursor-field" />
      </div>
    );
  }
}

export default InputCreditCard;
